import MobileDevice from './MobileDevice';

export default MobileDevice;
